import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]
  static classes = ["visible"]
  static values = {
    hasMessage: Boolean
  }

  connect() {
    this.hideTimeout = null
    this.handleNotify = this.handleNotify.bind(this)
    window.addEventListener("tinychart:notify", this.handleNotify)

    if (this.hasMessageValue && this.hasMessageTarget && this.messageTarget.textContent.trim().length > 0) {
      this.show()
    }
  }

  disconnect() {
    window.removeEventListener("tinychart:notify", this.handleNotify)
    clearTimeout(this.hideTimeout)
  }

  handleNotify(event) {
    const { message } = event.detail || {}
    if (!message) return

    this.messageTarget.textContent = message
    this.show()
  }

  show() {
    clearTimeout(this.hideTimeout)

    this.element.classList.remove(this.visibleClass)
    requestAnimationFrame(() => {
      this.element.classList.add(this.visibleClass)
    })

    this.hideTimeout = setTimeout(() => {
      this.element.classList.remove(this.visibleClass)
    }, 1800)
  }
}
